const SOLOMON_PRODUCTION_ROOT = "solomonlabs.org";
// Production Netlify deploys — resolve to the `Production` config block
// (prod API, prod OAuth client ids). These are permanent aliases: they came
// first as dark-production hostnames before the *.solomonlabs.org console
// domains were released, and they stay valid alongside those domains, so
// nothing here needs to change at domain launch.
const PRODUCTION_HOSTNAMES = [
    "solomon-v3.netlify.app",
    "solomon-labs-app.netlify.app",
    "solomon-platform.netlify.app",
    "solomon-yaas-client.netlify.app",
    "solomon-yaas-issuer.netlify.app",
    "issuer-legacy.solomonlabs.org",
    "solomon-wu-poc.netlify.app"
];
// Staging is each production site's `staging` branch deploy, which Netlify
// serves at `staging--<site>.netlify.app`. It resolves to the `Staging` config
// block so we can dogfood production-like feature flags (e.g. `yaasNav: false`)
// against dev APIs before promoting to Production. Only branch deploys of the
// production sites above count, so a branch deploy of an unrelated site stays
// Development.
const STAGING_BRANCH_PREFIX = "staging--";

function isProductionHostname(host: string): boolean {
    return (
        host === SOLOMON_PRODUCTION_ROOT ||
        host.endsWith(`.${SOLOMON_PRODUCTION_ROOT}`) ||
        PRODUCTION_HOSTNAMES.includes(host)
    );
}

export function isStagingHostname(host: string): boolean {
    if (!host.startsWith(STAGING_BRANCH_PREFIX)) return false;
    const site = host.slice(STAGING_BRANCH_PREFIX.length);
    return site.endsWith(".netlify.app") && PRODUCTION_HOSTNAMES.includes(site);
}

export function resolveAppEnvironment(hostname: string): "Production" | "Staging" | "Development" {
    return isProductionHostname(hostname) ? "Production" : isStagingHostname(hostname) ? "Staging" : "Development";
}
